import { inject, Injectable } from '@angular/core';
import { SharedDialogComponent } from '@mysrc/app/modules/fwcore/components';
import { DialogConfig } from '@mysrc/models/shared-dialog';
import {
  DialogCloseResult,
  DialogService,
  DialogSettings,
} from '@progress/kendo-angular-dialog';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SharedDialogService {
  private dialogService = inject(DialogService);

  openDialog(
    config: Omit<DialogSettings, 'content'>,
    additionalDetails: DialogConfig = { mode: 'confirmation' }
  ) {
    const dialogRef = this.dialogService.open({
      width: '50%',
      ...config,
      content: SharedDialogComponent,
    });

    const component = dialogRef.content.instance as SharedDialogComponent;
    component.config = config;
    component.additionalDetails = additionalDetails;
    return dialogRef.result.pipe(
      map((res) => {
        if (res instanceof DialogCloseResult) {
          return { action: 'close', form: component.formGroup.value };
        } else {
          return { action: res.text, form: component.formGroup.value };
        }
      })
    );
  }
}
